import styled from '@emotion/styled/macro';
import React from 'react';
import { useStats } from 'react-instantsearch';
import Translate from '../../utils/translation-functions';
import vars from '../../variables';

const CustomStats = () => {
  const {
    nbHits,

    query,
  } = useStats();

  return (
    <StyledStats aria-label="Number of search results">
      <p>
        {Translate('000 results', true).replace('000', nbHits)}{' '}
        {query ? `${Translate('for', true)} ”${query}” ` : ''}
      </p>
    </StyledStats>
  );
};

const StyledStats = styled.div`
  padding-top: 30px;
  padding-bottom: 30px;
  p {
    font-weight: ${vars.fontWeightRegular};
    font-size: 1.4rem;
  }
  p span {
    font-weight: ${vars.fontWeightBold};
  }
`;

export default CustomStats;
